import { SelectOnMobileTabsOnDesktop } from '@natu/ui/SelectOnMobileTabsOnDesktop';
import { excludeNullishFromArray } from '@natu/utils/excludeNullishFromArray';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import { type SBProps, type BlokItem, DynamicRender } from '../../../../utils';

interface SBTabsProps {
  ariaLabel?: string;
  body?: BlokItem[];
}

const wasValidTabProvidedInStoryblok = (tab: BlokItem): tab is BlokItem & { title: string } =>
  typeof tab.title === 'string' && typeof tab.content === 'object';

const getTabsFromBody = (body: BlokItem[]) => {
  const tabs = body.map(tab => {
    if (!wasValidTabProvidedInStoryblok(tab)) return null;

    return {
      id: tab._uid,
      title: tab.title,
      content: <DynamicRender data={tab.content as BlokItem | BlokItem[]} />,
    };
  });

  return excludeNullishFromArray(tabs);
};

export const SBTabs = ({ blok }: SBProps<SBTabsProps>) => {
  const { body, ariaLabel } = blok;

  if (!isArrayWithLength(body)) return null;

  const tabs = getTabsFromBody(body);

  return <SelectOnMobileTabsOnDesktop items={tabs} ariaLabel={ariaLabel} />;
};
